import { useRef } from "react";
import * as moment from 'moment';
import { toast } from "react-toastify";
import { ColumnApi, ExcelCell, ExcelExportParams, GridApi, GridReadyEvent } from "ag-grid-community";

export default function useExportOpoPaymentList() {
    const gridApiRef = useRef<GridApi>(null);
    const columnApiRef = useRef<ColumnApi>(null);

    const onGridReady = (e: GridReadyEvent) => {
        gridApiRef.current = e.api;
        columnApiRef.current = e.columnApi;
    };

    const toDataRow = (row: any, index: number): ExcelCell[] => [
        { data: { type: 'Number', value: String(index + 1) }, styleId: 'cell' },
        { data: { type: 'String', value: row.opoAlias }, styleId: 'cell' },
        { data: { type: 'Number', value: String(row.payNow) }, styleId: 'currency' },
    ];

    const toSubTotalRow = (amount: number): ExcelCell[] => [
        { data: { type: 'String', value: '' } },
        { data: { type: 'String', value: 'Sub Total' }, styleId: 'totalRowLabel' },
        { data: { type: 'Number', value: String(amount) }, styleId: 'totalRowValue' },
    ];

    const exportPaymentList = () => {
        if (!gridApiRef.current || !columnApiRef.current) return;

        if (gridApiRef.current.getSelectedRows().length === 0) {
            toast.error("Please select at least one row to export.");
            return;
        }

        const selectedRows = gridApiRef.current.getSelectedRows();
        const centers = selectedRows.filter((r: any) => r.centerId > 0);
        const opos = selectedRows.filter((r: any) => r.centerId === 0);

        const centersTotal = centers.reduce((sum: number, r: any) => sum + r.payNow, 0);
        const oposTotal = opos.reduce((sum: number, r: any) => sum + r.payNow, 0);
        const total = centersTotal + oposTotal;

        const name = moment().format('MMMM YYYY') + ' OPO AP';

        const headerRow: ExcelCell[] = [
            { data: { type: 'String', value: 'R#' }, styleId: 'headerRow' },
            { data: { type: 'String', value: 'OPO' }, styleId: 'headerRow' },
            { data: { type: 'String', value: 'Pay Now' }, styleId: 'headerRow' },
        ];

        const params: ExcelExportParams = {
            skipColumnHeaders: true,
            shouldRowBeSkipped: () => true,
            columnKeys: ['rank', 'opoAlias', 'payNow'],
            sheetName: name,
            fileName: `${name}.xlsx`,
            prependContent: [
                [
                    { data: { type: 'String', value: '' } },
                    { data: { type: 'String', value: name }, styleId: 'exportTitle', mergeAcross: 1 },
                ],
                [],
                [
                    { data: { type: 'String', value: '' } },
                    { data: { type: 'String', value: 'Centers (inhouse)' }, styleId: 'sectionLabel' },
                ],
                headerRow,
                ...centers.map(toDataRow),
                toSubTotalRow(centersTotal),
                [],
                [
                    { data: { type: 'String', value: '' } },
                    { data: { type: 'String', value: 'OPOs' }, styleId: 'sectionLabel' },
                ],
                headerRow,
                ...opos.map(toDataRow),
                toSubTotalRow(oposTotal),
                [],
                [
                    { data: { type: 'String', value: '' } },
                    { data: { type: 'String', value: 'Total' }, styleId: 'totalRowLabel' },
                    { data: { type: 'Number', value: String(total) }, styleId: 'totalRowValue' },
                ],
            ],
        };

        gridApiRef.current.exportDataAsExcel(params);
    };

    return { onGridReady, exportPaymentList };
}
